var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19L8 19L13 11L18.5 11C19.33 11 20 10.33 20 9.5C20 8.67 19.33 8 18.5 8L13 8L8 -5.24537e-07L6 -6.11959e-07L8.5 8L3 8L1.5 6L-2.62268e-07 6L1 9.5L-5.68248e-07 13L1.5 13L3 11L8.5 11L6 19Z",
    fill: "#72737F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightHorizontal);
export default __webpack_public_path__ + "static/media/flight-horizontal.b1a19a9b8b6c824a1f90a5eaffc49b16.svg";
export { ForwardRef as ReactComponent };